  async function buyNow(variantId) {
    try {
      // Optional: clear cart (only if truly needed)
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });

      // Add product
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      // Redirect to checkout
      window.location.href = '/checkout';
    } catch (error) {
      console.error('Buy Now error:', error);
    }
  }
